export default "__VITE_ASSET__c25297bc__"